/**
 * Helper: Smooth Scroll
 * ------------------------------------------------------------------------------
 * A smooth scroll helper using the smooth-scroll package.
 *
 * @namespace smoothScroll
 */
import {on, handleize} from './utils';

/**
 * Create a new smooth scroll instance.
 */
export default () => {

  /**
   * Attributes.
   */
  const attributes = {
    toggle: 'js-smooth-scroll',
  };

  /**
   * Smooth scroll config.
   */
  const config = {
    header: '.site-header',
  };

  /**
   * Initiate the component.
   */
  function init() {
    setClickEvents();
  }

  /**
   * Set click events.
   */
  function setClickEvents() {
    on('click', (event) => handleClickEvent(event));
  }

  /**
   * Handle click events.
   * @param {Object} event - The event object.
   */
  function handleClickEvent(event) {
    const target = event.target;
    let anchor = document.getElementById(target.getAttribute(attributes.toggle));

    if (target.tagName === 'a') {
      anchor = document.getElementById(target.getAttribute('href'));
    }

    if (!isToggle(target)) {
      return;
    }

    event.preventDefault();

    window.scroll({
      top: getElementOffset(anchor),
      left: 0,
      behavior: 'smooth',
    });

    if (anchor.id === "spare-parts-section") {
      window.dataLayer.push({
        event: 'GAevent',
        eventID: '14',
        eventCategory: 'product',
        eventAction: 'button',
        eventLabel: 'spare_parts',
      });
    } else if (anchor.id.includes('ProductDesigner')) {
      window.dataLayer.push({
        event: 'GAevent',
        eventID: '15',
        eventCategory: 'product',
        eventAction: 'design',
        eventLabel: handleize(event.target.innerHTML.trim()).replace(/-/g, '_'),
      });
    }
  }

  /**
   * Returns the elements offset.
   * @param {HTMLElement} element - The element.
   */
  function getElementOffset(element) {
    let offset = element.getBoundingClientRect().top + document.documentElement.scrollTop;

    if (config.header) {
      const header = document.querySelector(config.header);
      offset -= header.clientHeight;
    }

    return offset;
  }

  /**
   * Returns of the element is a toggle.
   * @param {HTMLElement} element - The toggle element.
   */
  function isToggle(element) {
    return element.hasAttribute(attributes.toggle);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
